import { useCallback } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";
import { API } from "@/lib/api";

export function useAdminApi() {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data, params) => {
    const token = await getToken();
    const r = await axios({ method, url: `${API}${url}`, data, params, headers: { Authorization: `Bearer ${token}` } });
    return r.data;
  }, [getToken]);
}

export const STATUS_STYLES = {
  CONFIRMED: "bg-mint text-teal border-mint-border",
  PENDING_PAYMENT: "bg-amber-50 text-amber-700 border-amber-200",
  COMPLETED: "bg-slate-100 text-slate-700 border-slate-200",
  CANCELLED: "bg-red-50 text-red-600 border-red-200",
};

export const selectCls = "h-10 rounded-xl border border-input bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring";
export const btnPrimary = "inline-flex items-center justify-center gap-2 h-10 px-4 rounded-full bg-teal text-white text-sm font-semibold hover:bg-teal-dark disabled:opacity-50 transition-colors";
export const btnGhost = "inline-flex items-center justify-center gap-1.5 h-9 px-3 rounded-full border border-slate-200 bg-white text-sm font-medium hover:bg-mint disabled:opacity-50 transition-colors";
export const cardCls = "rounded-3xl bg-white border border-slate-200/80 p-5 sm:p-6";
